module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"copyLink":"Copy Link","share":"Share Product","linkCopied":"Link copied to clipboard"},"ar":{"copyLink":"انسخ الرابط","share":"شارك المنتج","linkCopied":"تم نسخ الرابط"}}')
  delete Component.options._Ctor
}
